export default {
  PGD: 'HomeSearch',
  School: 'SchoolSearch',
  Profile: 'ProfileSearch',
  GeneralPortal: 'general',
}
